export { default } from './service_card';
